"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = exports.ApiError = exports.ApiErrorMessages = void 0;
var apisauce_1 = __importDefault(require("apisauce"));
var apiSauceInstance;
exports.ApiErrorMessages = {
    not_setup: 'Api not setup, call API.setup(config);'
};
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(type) {
        return _super.call(this, exports.ApiErrorMessages[type]) || this;
    }
    return ApiError;
}(Error));
exports.ApiError = ApiError;
var API = /** @class */ (function () {
    function API() {
    }
    API.setup = function (config, requestTransFormation) {
        this.setupWithOptions(config, { requestTransFormation: requestTransFormation });
    };
    API.setupWithOptions = function (config, options) {
        apiSauceInstance = apisauce_1.default.create(config);
        var requestTransFormation = options.requestTransFormation, responseInterceptor = options.responseInterceptor;
        if (requestTransFormation && !!requestTransFormation.addRequestTransform) {
            apiSauceInstance.addRequestTransform(requestTransFormation.addRequestTransform);
        }
        if (requestTransFormation && !!requestTransFormation.addResponseTransform) {
            apiSauceInstance.addResponseTransform(requestTransFormation.addResponseTransform);
        }
        if (requestTransFormation && !!requestTransFormation.asyncRequestTransform) {
            apiSauceInstance.addAsyncRequestTransform(requestTransFormation.asyncRequestTransform);
        }
        if (requestTransFormation && !!requestTransFormation.monitor) {
            apiSauceInstance.addMonitor(requestTransFormation.monitor);
        }
        if (responseInterceptor) {
            var onFulfilled = responseInterceptor.onFulfilled, onRejected = responseInterceptor.onRejected;
            apiSauceInstance.axiosInstance.interceptors.response.use(onFulfilled, onRejected);
        }
    };
    API.get = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var url, query, headers, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!apiSauceInstance) {
                            throw new ApiError('not_setup');
                        }
                        url = args.url, query = args.query, headers = args.headers;
                        this.setHeaders(headers);
                        return [4 /*yield*/, apiSauceInstance.get(url, query)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.returnResponse(response)];
                }
            });
        });
    };
    API.post = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var url, body, headers, onUploadProgress, cancelToken, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!apiSauceInstance) {
                            throw new ApiError('not_setup');
                        }
                        url = args.url, body = args.body, headers = args.headers, onUploadProgress = args.onUploadProgress, cancelToken = args.cancelToken;
                        this.setHeaders(headers);
                        return [4 /*yield*/, apiSauceInstance.post(url, body, {
                                onUploadProgress: onUploadProgress,
                                cancelToken: cancelToken
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.returnResponse(response)];
                }
            });
        });
    };
    API.put = function (args) {
        return __awaiter(this, void 0, void 0, function () {
            var url, body, headers, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!apiSauceInstance) {
                            throw new ApiError('not_setup');
                        }
                        url = args.url, body = args.body, headers = args.headers;
                        this.setHeaders(headers);
                        return [4 /*yield*/, apiSauceInstance.put(url, body)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.returnResponse(response)];
                }
            });
        });
    };
    API.reset = function () {
        this.setHeaders({ Authorization: null });
    };
    API.setHeaders = function (headers) {
        if (!apiSauceInstance) {
            throw new ApiError('not_setup');
        }
        if (headers) {
            apiSauceInstance.setHeaders(headers);
        }
    };
    API.returnResponse = function (response) {
        if (!response.ok && response.problem) {
            var data = response.data;
            var error = response && data && (data.title || data.message)
                ? data.title || data.message
                : response && response.originalError && response.originalError.message;
            return Promise.reject({
                message: error,
                payload: response.data
            });
        }
        return response.data;
    };
    API.createCancelToken = function () {
        return apisauce_1.default.CancelToken.source();
    };
    return API;
}());
exports.API = API;
//# sourceMappingURL=api.js.map